export default __webpack_public_path__ + "static/media/logo.089752b9.png";